// Utils
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { ButtonProps } from '@/components/base/Button';
import Button from '@/components/base/Button';
// Components
import Icon from '@/components/base/Icon';
import type { ModalProps } from '@/components/base/Modal';

export type AlbumsCreateButtonProps = Pick<ButtonProps, 'size'> & {
    onClick: ModalProps['onDismiss'];
};

const AlbumsCreateButton = ({ size = 'md', onClick }: AlbumsCreateButtonProps) => {
    const { t } = useTranslation();

    return (
        <div className="w-full md:w-52">
            <Button
                id="create-new-campaign-button"
                className="create-new-add w-full space-x-2 md:w-52"
                size={size}
                onClick={onClick}>
                <Icon icon="plus-border" />
                <span>{t('content:create_album')}</span>
            </Button>
        </div>
    );
};

export default AlbumsCreateButton;
